{
  "aboutme": {
    "name": "Fabian Aps"
  },
  "logo": {
    "alt": "mcpeaps_HD Logo"
  },
  "navigation": "Navigation",
  "cookieConsent": {
    "categories": {
      "multimedia": {
        "title": "Multimedia"
      },
      "socialMedia": {
        "title": "Social Media"
      }
    }
  },
  "linkhub": {
    "sections": {
      "socialMedia": {
        "title": "Social Media",
        "instagram": {
          "title": "Instagram",
          "headding": "@mcpeaps_hd"
        },
        "tiktok": {
          "title": "TikTok",
          "headding": "@mcpeaps_hd"
        },
        "threads": {
          "title": "Threads",
          "headding": "@mcpeaps_hd"
        },
        "bsky": {
          "title": "Bluesky",
          "headding": "@mcpeapsunterstrichhd.dev"
        },
        "twitter": {
          "title": "X/Twitter",
          "headding": "@mcpeaps_HD"
        },
        "discord": {
          "title": "Discord",
          "headding": "Community Server"
        },
        "youtube": {
          "title": "YouTube",
          "headding": "mcpeaps_HD"
        }
      },
      "websites": {
        "title": "Websites",
        "myWebsite": {
          "headding": "mcpeapsunterstrichhd.dev"
        },
        "cbps": {
          "title": "comboom.sucht"
        },
        "blogCBPS": {
          "title": "comboom.sucht Blog"
        }
      },
      "other": {
        "gitlab": {
          "title": "Gitlab",
          "headding": "@mcpeaps_HD"
        },
        "github": {
          "title": "GitHub",
          "headding": "@mcpeapsUnterstrichHD"
        },
        "song": {
          "headding": "Festival Dream"
        }
      }
    }
  },
  "cv": {
    "about": {
      "address": {
        "berlin": "Berlin"
      }
    },
    "education": {
      "badges": {
        "batchlor_of_science": "Bachelor of Science"
      }
    }
  },
  "projects": {
    "items": {
      "simplesql": {
        "title": "simplesql"
      },
      "klassenApp": {
        "title": "ITA 12 App"
      },
      "klassenWebsite": {
        "title": "ITA 12 Website"
      },
      "simpleSqlRunner": {
        "title": "Simple SQL Runner"
      },
      "dotfilesMacos": {
        "title": "macOS Dotfiles"
      },
      "nixConfig": {
        "title": "NixOS Config"
      },
      "dotfilesLinux": {
        "title": "Linux Dotfiles"
      },
      "cbpsWebsite": {
        "title": "comboom.sucht Website"
      },
      "cbpsApp": {
        "title": "comboom.sucht App"
      }
    }
  }
}
